import { Injectable, StaticClassProvider } from '@angular/core';

import { bcpLocaleToSi, siLocaleToBcp, bcpLocaleToNgFilename } from '../../utils/locale-mapping';
import { defaultBcpLocale, defaultSiLocale } from '../../definitions';

@Injectable()
export class LocaleResolverService {
  constructor() {}

  private normalizeBcpLocale(bcpLocale: string): string {
    return bcpLocale.toLowerCase().replace('-', '_');
  }

  private normalizeSiLocale(siLocale: string): string {
    return siLocale.toUpperCase();
  }

  resolveFromBcpToSiOrNull(bcpLocale: string): string | null {
    return bcpLocaleToSi.get(this.normalizeBcpLocale(bcpLocale)) || null;
  }

  resolveFromBcpToSi(bcpLocale: string): string {
    return this.resolveFromBcpToSiOrNull(bcpLocale) || defaultSiLocale;
  }

  resolveFromSiToBcpOrNull(siLocale: string): string | null {
    return siLocaleToBcp.get(this.normalizeSiLocale(siLocale)) || null;
  }

  resolveFromSiToBcp(siLocale: string): string {
    return this.resolveFromSiToBcpOrNull(siLocale) || defaultBcpLocale;
  }

  resolveFromBcpToNgFilename(bcpLocale: string): string {
    return bcpLocaleToNgFilename.get(this.normalizeBcpLocale(bcpLocale)) || bcpLocaleToNgFilename.get(defaultBcpLocale);
  }
}

export const LocaleResolverServcieProvider: StaticClassProvider = {
  provide: LocaleResolverService,
  useClass: LocaleResolverService,
  deps: []
};
